module.exports = __webpack_public_path__ + "img/time-icon-b.c38944e5.svg";